module.exports = {
    enable: process.env.LIVECHAT_ENABLED === 'true',
    provider: process.env.LIVECHAT_PROVIDER || 'zendesk',
    license: process.env.LIVECHAT_LICENSE,
    showChatButtonOnMobile: process.env.LIVECHAT_SHOW_CHAT_BUTTON_ON_MOBILE ? process.env.LIVECHAT_SHOW_CHAT_BUTTON_ON_MOBILE === 'true' : true,
    zendeskConfig: {
        departments: process.env.LIVECHAT_ZENDESK_DEPARTMENTS ? process.env.LIVECHAT_ZENDESK_DEPARTMENTS.split(',') : [],
        tags: process.env.LIVECHAT_ZENDESK_TAGS ? process.env.LIVECHAT_ZENDESK_TAGS.split(',') : [],
    },
};